<template>
    <div class="modal fade center"
         id="EventConfigModal"
         tabindex="-1"
         role="dialog"
         aria-labelledby="exampleModalLabel"
         aria-hidden="true">
        <div class="modal-dialog modal-lg" role="document" style="width:50%;max-width:70%;">
            <div class="modal-content">
                <div class="modal-header">
                    <h3 class="modal-title pull-left">Dados do evento:</h3>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="modal-body">
                    <div class="row" 
                     >
                        <h4>
                            Horário em que será realizado:
                        </h4>
                        <input type="time" v-model="event_time"  class="form-control"/>
                        <h4>
                            Área:
                        </h4>
                        <v-select 
                        :options="teams"
                        label="name"
                        v-model="selectedTeam"
                        ></v-select>            
                    </div>
                </div>
                <div class="modal-footer" style="z-index:-1">
                    <button @click="Cancel" type="button" class="btn btn-danger pull-left" aria-label="Close">
                        Cancelar
                    </button>
                    <button @click="Apply" style="width:81px" type="button" class="btn btn-success" aria-label="Close">
                        Gerar
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                teams: [],
                event_time: '',
                selectedTeam: '',
            };
        },
        props: ["newEvent"],
        methods: {
        Cancel(){
            this.$parent.getEvents();
            $("#EventConfigModal").modal("hide");
        },
        Apply() {
            if(this.event_time && this.selectedTeam){
                this.$parent.saveEvent(this.newEvent.id, this.newEvent.start.format(), 5, this.event_time, this.selectedTeam);
                this.event_time = '';
                this.selectedTeam = '';
                $("#EventConfigModal").modal("hide");
            } else {
                this.$message(
                  null,
                  "Tempo e Área são obrigatórios.",
                  "error"
                );
            }
        },
        getTeams() {
            const self = this;
            const api =
            self.$store.state.api + "teams?paginated=false&with[]=themes";
                    
            self.$http
              .get(api)
              .then((response) => {
                self.teams = response.data.data;
              })
              .catch((error) => {
                self.$message(
                  null,
                  "Ocorreu um erro ao buscar as informações",
                  "error"
                );
              });
            },
        },
        mounted(){
            this.getTeams();
        }
    }
</script>

<style scoped>
    .scroll-modal {
        max-height: 480px;
        overflow: overlay;
    }

    @media screen and (max-width: 767px) {
        .scroll-modal {
            max-height: unset;
        }
    }

    .center {
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
    }
</style>




// WEBPACK FOOTER //
// src/components/Schedule/EventConfigModal.vue